import { createFileRoute } from "@tanstack/react-router";
import Footer from "lib/components/footers/LandingPageFooter";
import Navbar from "lib/components/home/Navbar";
import ResetPasswordForm from "lib/components/home/ResetPasswordForm";
import getPageTitle from "lib/utils/getPageTitle";
import { useEffect, useState } from "react";
import { Helmet as Head } from "react-helmet-async";
import styles from "../Home.module.scss";

function ResetPasswordPage() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return <div style={{ visibility: "hidden" }} />;
  }

  return (
    <div className={styles.wrapper}>
      <Head>
        <title>{getPageTitle("Reset Password")}</title>
        <meta name="robots" content="noindex" />
      </Head>
      <Navbar />
      <div className="grid-container full-height">
        <ResetPasswordForm />
      </div>
      <Footer />
    </div>
  );
}

export const Route = createFileRoute("/account/reset-password")({
  component: ResetPasswordPage,
});
